/**
 * Do not edit directly, this file was auto-generated.
 */

export const BreakpointMobile = "320";
export const BreakpointMobileXl = "480";
export const BreakpointTablet = "481";
export const BreakpointTabletXl = "768";
export const BreakpointLaptop = "769";
export const BreakpointLaptopXl = "1024";
export const BreakpointDesktop = "1025";
export const BreakpointDesktopXl = "1219";
export const BreakpointTv = "1220";
export const ColorDarkBg100 = "#141218";
export const ColorDarkBg80 = "#1D1B20";
export const ColorDarkBg60 = "#2B2930";
export const ColorDarkBg40 = "#49454F";
export const ColorDarkBg20 = "#E6E0E9";
export const ColorDarkBlack100 = "#141218";
export const ColorDarkBlack80 = "#1D1B20";
export const ColorDarkBlack60 = "#2B2930";
export const ColorDarkContrast100 = "#FEF7FF";
export const ColorDarkContrast80 = "#E6E0E9";
export const ColorDarkContrast60 = "#CAC4D0";
export const ColorDarkContrast40 = "#49454F";
export const ColorDarkContrast20 = "#322F35";
export const ColorDarkError = "#E70D4F";
export const ColorDarkInfo = "#339AF0";
export const ColorDarkPrimary = "#FEF7FF";
export const ColorDarkSecondary = "#E6E0E9";
export const ColorDarkTertiary = "#CAC4D0";
export const ColorDarkSuccess = "#14A38C";
export const ColorDarkWarning = "#EDB464";
export const ColorDarkWhite100 = "#FEF7FF";
export const ColorDarkWhite80 = "#E6E0E9";
export const ColorDarkWhite60 = "#CAC4D0";
export const ColorLightBg100 = "#FEF7FF";
export const ColorLightBg80 = "#E6E0E9";
export const ColorLightBg60 = "#CAC4D0";
export const ColorLightBg40 = "#49454F";
export const ColorLightBg20 = "#322F35";
export const ColorLightBlack100 = "#141218";
export const ColorLightBlack80 = "#1D1B20";
export const ColorLightBlack60 = "#2B2930";
export const ColorLightContrast100 = "#141218";
export const ColorLightContrast80 = "#1D1B20";
export const ColorLightContrast60 = "#2B2930";
export const ColorLightContrast40 = "#49454F";
export const ColorLightContrast20 = "#E6E0E9";
export const ColorLightError = "#E70D4F";
export const ColorLightInfo = "#339AF0";
export const ColorLightPrimary = "#141218";
export const ColorLightSecondary = "#1D1B20";
export const ColorLightTertiary = "#2B2930";
export const ColorLightSuccess = "#14A38C";
export const ColorLightWarning = "#EDB464";
export const ColorLightWhite100 = "#FEF7FF";
export const ColorLightWhite80 = "#E6E0E9";
export const ColorLightWhite60 = "#CAC4D0";
